import { render, staticRenderFns } from "./PatientFamilyHistoryCard.vue?vue&type=template&id=668b16e0&scoped=true&"
import script from "./PatientFamilyHistoryCard.vue?vue&type=script&lang=js&"
export * from "./PatientFamilyHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./PatientFamilyHistoryCard.vue?vue&type=style&index=0&id=668b16e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b16e0",
  null
  
)

export default component.exports